<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <div>
      <!-- Table Container Card -->
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <!-- Datos cargados -->
        <b-card-header class="pb-0">
          <b-card-title>Reinscripciones
          </b-card-title>
          <b-card-text class="font-small-2 mr-25 mb-0">
            Datos cargados <b>{{ updatedAt }}</b>
          </b-card-text>
        </b-card-header>
        <app-collapse
          id="instrucciones"
          accordion
          type="margin"
          class="mx-4"
        >

          <app-collapse-item
            class="bg-light-secondary rounded"
            title="INSTRUCCIONES"
          >

            <div class="p-1">
              <b-card-text>
                <ol>
                  <li>Debe de estar dado de alta el <b>periodo</b> al que  se desea reinscribir</li>
                  <li>Debe de estar dado de alta <b>todos los cursos</b> relacionados al periodo que se desea reinscribir</li>
                  <li>Los alumnos <b>deben de tener una calificación</b> en el periodo anterior al que se desea reinscribir</li>
                  <li>Cumplidos los puntos [1, 2, 3] Seleccione un <b>plan de estudios</b></li>
                  <li>Seleccione un <b>periodo anterior al que se quiera reinscribir</b></li>
                  <li>Espere mientras se llena  la información</li>
                  <li>Seleccione el tipo de alumno que desea reinscribir</li>
                  <li>Despues de ver la lista llena, click en el botón <b>Acciones - Reinscribir</b></li>
                  <li>Nota: para los alumnos <b>repetidores</b> es uno por uno dando click en  <feather-icon
                    icon="CheckCircleIcon"
                    class="text-primary cursor-pointer"
                    size="20"
                  /> (solo se habilitará cuando la solicitud de recursamiento sea aceptada)</li>
                </ol>
              </b-card-text>
            </div>
          </app-collapse-item>

        </app-collapse>
        <b-card-header class="mx-4">
          <b-card-text class="p-1 bg-light-primary rounded">
            <p><b>Nota importante</b></p>
            <p>* Los alumnos con Beca 100% son re-inscritos en automático.</p>
            <p>* Los alumnos Regulares S/B o %: necesitan que su orden sea autorizada en el modulo de solicitudes.</p>
            <p>* Los alumnos Irregulares necesitan una solicitud de recursamiento. [si mantiene la beca es reinscrito en automático, si no tiene beca es necesaria su autorización en solicitudes].</p>
            <p>* Los alumnos con baja están disponibles para re-inscribirse; si no se re-inscriben, pueden ser candidatos a una baja académica.</p>
          </b-card-text>
        </b-card-header>
        <div class="m-2">
          <b-row class="m-2">
            <b-col
              cols="12"
              md="6"
            >
              <selectplan
                :filtrado="true"
                @selectedplan="idplan=$event"
              />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >    <selectperiodo
                   :idplan="idplan"
                   reinsc
                   @selectedperiodo="$event && $event.periodo ? idperiodo = $event.periodo : idperiodo = null; loadusuarios()"
                 />
              <b-row>
                <b-col>
                  <p class="m-0">
                    <small>Regulares con beca: {{ numeroRB }}</small>
                  </p>
                  <p class="m-0">
                    <small> Regulares SB o con %:  {{ numeroRO }}</small>
                  </p>
                </b-col>
                <b-col>

                  <p class="m-0">
                    <small>Alumnos Irreculares:  {{ numeroRC }} </small>
                  </p>
                  <p class="m-0">
                    <small> Alumnos baja:  {{ numeroBA }}</small>
                  </p>
                </b-col>
                <b-col>

                  <p class="mb-0 mt-2">
                    <small><b>Alumnos sin agenda: {{ numeroBA + numeroRB + numeroRC + numeroRO }}</b></small>
                  </p>
                </b-col>
              </b-row>

            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="12"
            >
              <h4 class="mb-2">
                Filtros
              </h4>
              <!-- Filters -->
              <filtros
                v-show="!errorContent.filters"
                :agenda-options="agendaOptions"
                :agenda-filter.sync="varFilters.agenda"
                :orden-options="ordenOptions"
                :orden-filter.sync="varFilters.orden"
                :nivel-options="nivelOptions"
                :nivel-filter.sync="varFilters.nivel"
                :tipo-alumno.sync="varFilters.tipoAlumno"
                :load="loader"
              />
            </b-col>
          </b-row>
          <b-row>
            <!-- Cantidad de elementos por página -->
            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span>Mostrar</span>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
            </b-col>
            <!-- Buscador -->
            <b-col
              cols="12"
              md="9"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon
                      :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                      :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                      @click="searchQuery != '' ? searchQuery = '' : ''"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="searchQuery"
                    placeholder="Buscar por nombre del alumno"
                  />
                </b-input-group>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="3"
            />
            <b-col
              cols="12"
              md="3"
            />
            <b-col
              cols="12"
              md="3"
            />

            <b-col
              cols="12"
              md="3"
              class="text-right"
            >
              <b-dropdown
                v-if="varFilters.tipoAlumno!='RP'"
                class="m-2"
                text="Acciones"
                variant="primary"
              > <b-dropdown-item
                @click="reinscribirlista(null)"
              >
                Re inscribir
              </b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-row>
        </div>
        <b-overlay
          rounded="sm"
          :show="isBusyTable"
          opacity="0"
        >
          <b-table
            v-if="random"
            ref="refDataListTable"
            class="position-relative"
            empty-text="No se encontraron resultados"
            primary-key="table_usuarios_moodle"
            responsive
            show-empty
            striped
            :items="fetchData"
            :fields="tableColumns"
            :sort-desc.sync="isSortDirDesc"
            :sort-by.sync="sortBy"
            @refreshed="stoppageload"
          >
            <template #cell(nombreCompleto)="data">
              <div v-if="data.item !== undefined">
                <p class="m-0">
                  Matricula | {{ data.item.matricula }}
                </p>
                <p class="m-0">
                  {{ data.item.nombreCompleto }}
                </p>
                <p class="m-0">
                  {{ data.item.emal_principal }}
                </p>
                <p class="m-0">
                  Tel: {{ data.item.telefono1 }}
                </p>
                <p
                  v-if=" data.item.beca"
                  class="m-0"
                ><b>
                  {{ data.item.beca_desc }} | {{ data.item.beca }}</b>
                </p>
                <p class="m-0">
                  <b> Generación {{ data.item.generacion }} </b>
                </p>
              </div>
            </template>
            <template #cell(materias)="data">
              <div v-if="data.item.kardex.length > 0 ">
                <div v-if=" data.item.kardex.filter(word => word.status === 'C1' || word.status === 'C2' || word.status === 'C3').length > 0">
                  <span>Cursando</span><br>

                  <p
                    v-for="(kardex, index) in data.item.kardex.filter(word => word.status === 'C1' || word.status === 'C2' || word.status === 'C3')"
                    :key="'cursando' + index"
                    class="m-0"
                  >
                    <b-badge
                      :id="`${index}-${data.item.matricula}-badge`"
                      variant="warning"
                      pill
                      class="badge-round"
                    >
                      {{ kardex.status }} : {{ kardex.cal_fin }} |
                      {{ kardex.clave }} |
                      {{ kardex.materia_clave }} |
                      Nivel {{ kardex.orden }}
                    </b-badge>
                    <b-tooltip
                      :title="kardex.nombre_materia"
                      :target="`${index}-${data.item.matricula}-badge`"
                    />
                  </p>
                </div>
                <div v-if=" data.item.kardex.filter(word => word.status === 'AP' || word.status === 'AE' || word.status === 'AR' || word.status === 'AX').length > 0">
                  <span>Aprobadas</span><br>
                  <p
                    v-for="(kardex2, index2) in data.item.kardex.filter(word => word.status === 'AP' || word.status === 'AE' || word.status === 'AR' || word.status === 'AX')"
                    :key="'aprobado' + index2"
                    class="m-0"
                  >
                    <b-badge
                      :id="`${index2}-${data.item.matricula}-badge-ap`"
                      variant="success"
                      pill
                      class="badge-round"
                    > {{ kardex2.status }} : {{ kardex2.cal_fin }} |
                      {{ kardex2.clave }} |
                      {{ kardex2.materia_clave }} |
                      Nivel {{ kardex2.orden }}
                    </b-badge>
                    <b-tooltip
                      :title="kardex2.nombre_materia"
                      :target="`${index2}-${data.item.matricula}-badge-ap`"
                    />
                  </p>
                </div>
                <div v-if=" data.item.kardex.filter( word => word.status === 'BD' || word.status === 'EX' || word.status === 'NA' || word.status === 'BT' ).length > 0">
                  <span>Otros estados</span><br>
                  <p
                    v-for="(kardex3, index3) in data.item.kardex.filter( word => word.status === 'BD' || word.status === 'EX' || word.status === 'NA' || word.status === 'BT')"
                    :key="'otros' + index3"
                    class="m-0"
                  >
                    <b-badge
                      :id="`${index3}-${data.item.matricula}-badge-ot`"
                      :variant="kardex3.status === 'BT' ? 'info':'danger'"
                      pill
                      class="badge-round"
                    >
                      {{ kardex3.status }} : {{ kardex3.cal_fin }} |
                      {{ kardex3.clave }} |
                      {{ kardex3.materia_clave }} |
                      Nivel {{ kardex3.orden }}
                    </b-badge>
                    <b-tooltip
                      :title="kardex3.nombre_materia"
                      :target="`${index3}-${data.item.matricula}-badge-ot`"
                    />
                  </p>
                </div>
              </div>
            </template>
            <template #cell(automatico)="data">
              <b-form-checkbox
                v-if="data.item.automatico==2"
                v-model="data.item.automatico"
                :unchecked-value="1"
                :value="2"
                switch
                @change="submitForm(data.item)"
              />
              <div v-if="data.item.tipoAlumno === 'RP'">
                <div v-if="data.item.recursamiento.length <= 0 && data.item.tipoAlumno==='RP'">
                  <p><b>SIN CARTA COMPROMISO</b></p>
                </div>
                <div v-if="data.item.recursamiento.length > 0">
                  <p><b> CARTA COMPROMISO </b></p>
                  <div
                    v-for="(solicitud) in data.item.recursamiento"
                    :id="'solicitud' + solicitud.id"
                    :key="'solicitud' + solicitud.id"
                    class="m-0"
                  >
                    <p>Solicitud: {{ timestampToDate( solicitud.fecha_solicitud , 'LLL') }}</p>
                    <p>
                      <b v-if="solicitud.resolucion===null">En revisión</b>
                      <b v-if="solicitud.resolucion===0">Rechazada</b>
                      <b v-if="solicitud.resolucion===1">Aceptada</b>
                      <small v-if="solicitud.resolucion!==null">
                        {{ timestampToDate( solicitud.fecha_resol , 'LLL') }}
                      </small>
                    </p>
                    <b-tooltip
                      :title="solicitud.motivo"
                      :target="'solicitud' + solicitud.id"
                      placement="right"
                    />
                    <hr>
                  </div>

                  <div
                    v-if="checkresolucion(data.item.recursamiento)"
                    class="text-nowrap text-center"
                  >
                    <div v-if="data.item.orden_activa!==2">
                      <b-link
                        :id="`btn-row-${data.item.matricula}`"
                        class="font-weight-bold text-secondary"
                        @click="reinscribirlista(data.item)"
                      >
                        <feather-icon
                          icon="CheckCircleIcon"
                          class="text-primary cursor-pointer"
                          size="20"
                        />
                      </b-link>
                      <b-tooltip
                        title="Agendar alumno"
                        :target="`btn-row-${data.item.matricula}`"
                      />
                    </div>
                  </div>

                </div>
              </div>
              <div v-if="data.item.nextagenda === 1">
                <p><b>SIN AGENDA: {{ data.item.clave_next_periodo }} </b></p>
                <p><small>Este alumno no podrá ser evaluado</small></p>
              </div>
              <div v-if="data.item.orden_activa === 2">
                <p><b> ORDENES ACTIVAS </b></p>
                <div
                  v-for="(ordenes, indexorden) in data.item.ordenes"
                  :id="'orden' + indexorden"
                  :key="'orden' + indexorden"
                  class="m-0"
                >
                  <p class="m-0"><small>
                    ORDEN: {{ ordenes.id }}
                  </small></p>
                  <p
                    v-if="ordenes.fecha!==null"
                    class="m-0"
                  ><small>
                    FECHA: {{ formatDate( ordenes.fecha, { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }}
                  </small></p>
                  <p class="m-0"><small>
                    REFERENCIA: {{ ordenes.referencia }}
                  </small></p>
                  <div
                    class="text-nowrap text-center"
                  >
                    <b-link
                      :href="`${routeData}${shipcode(ordenes.id )}/`"
                      target="_blank"
                      class="font-weight-bold text-secondary"
                    >
                      <feather-icon
                        :id="`usuario-row-${indexorden}-editar-icon`"
                        icon="ExternalLinkIcon"
                        class="text-primary cursor-pointer"
                        size="20"
                      />
                    </b-link>
                    <b-tooltip
                      title="Editar orden"
                      :target="`usuario-row-${indexorden}-editar-icon`"
                    />
                  </div>
                  <b-tooltip
                    :title="ordenes.observaciones"
                    :target="'orden' + indexorden"
                    placement="right"
                  />
                  <hr>
                </div>
              </div>
              <p v-if="data.item.nextagenda === 2 && data.item.automatico === 2">
                <b> AGENDADO: {{ data.item.clave_next_periodo }} </b> </p>
            </template>
          </b-table>
        </b-overlay>
        <!-- Table's footer & pagination -->
        <div class="mx-2 mb-2">
          <b-row>
            <!-- Leyenda de cuantos elementos se muestran -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BCardHeader,
  BCardText,
  BCardTitle,
  BInputGroup,
  BInputGroupPrepend,
  BOverlay,
  BBadge,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, onMounted, watch, getCurrentInstance,
} from '@vue/composition-api'
import {
  lastUpdate,
  timestampToDate,
  nombreModalidad,
  avatarText,
  formatDate,
} from '@core/utils/filter'
import store from '@/store'
import {
  configTableUsuarios, useUsuariosCatalogos, variablesFiltro, fetchUsuariosReinscripcion,
} from '@/views/campus/servicio-escolar/components/reinscripciones/useUsuariosReinscripcion'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import selectplan from '@/views/components/select-plan.vue'
import selectperiodo from '@/views/components/select-periodos.vue'
import { postData } from '@core/utils/http/general'
import { shipcode } from '@core/utils/utils'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import hostname from '@core/utils/http/config-hostname'
import filtros from './Filters.vue'

export default {
  components: {
    BCard,
    AppCollapse,
    AppCollapseItem,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    vSelect,
    BOverlay,
    BBadge,
    selectplan,
    selectperiodo,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    BTooltip,
    filtros,
    BLink,
  },
  setup() {
    const routeData = ref(`${hostname().host}/app/compras/${(store.state.cuenta.rolSelected.id !== 1) ? 'ordenes/preview' : 'preview'}/`)
    const idplan = ref(null)
    const random = ref(false)
    const loader = ref(false)
    const idperiodo = ref(null)
    const numeroRB = ref(null)
    const numeroBA = ref(null)
    const numeroRC = ref(null)
    const numeroRO = ref(null)
    const nivelOptions = ref([])
    const updatedAt = ref(lastUpdate())
    const errorContent = ref({ filters: false, table: false })
    const { tableColumns } = configTableUsuarios()
    const { varFilters } = variablesFiltro()
    const { configRequest } = fetchUsuariosReinscripcion({ id_periodo: idperiodo, id_plan: idplan })
    const {
      ordenOptions, agendaOptions,
    } = useUsuariosCatalogos()
    const vm = getCurrentInstance().proxy
    const {
      fetchData, refetchData, refDataListTable,
      dataMeta,
      dynamicParamRequest,
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc, dataAux,
      isBusyTable,
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const actualizarTabla = async (inicial = 'RB') => {
      await refetchData(true)

      varFilters.value.agenda = null
      varFilters.value.orden = null
      varFilters.value.nivel = null
      varFilters.value.tipoAlumno = inicial
    }
    const loadusuarios = () => {
      perPage.value = (perPage.value === 100) ? 50 : 100
      loader.value = true
      random.value = true
      actualizarTabla()
    }
    const cancelar = motivo => {
      loader.value = false
      vm.$swal({
        title: 'Cancelado',
        html: `<b>${motivo}</b>`,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    }
    const stoppageload = () => {
      loader.value = false

      numeroRB.value = dataAux.value.filter(word => word.tipoAlumno === 'RB' && word.nextagenda === 1).length
      numeroRO.value = dataAux.value.filter(word => word.tipoAlumno === 'RO' && word.nextagenda === 1).length
      numeroRC.value = dataAux.value.filter(word => word.tipoAlumno === 'RP' && word.nextagenda === 1).length
      numeroBA.value = dataAux.value.filter(word => word.tipoAlumno === 'BA' && word.nextagenda === 1).length
    }
    const reinscribirlista = registro => {
      const listaprefinal = dataAux.value.filter(word => (word.automatico === 2 && word.tipoAlumno === varFilters.value.tipoAlumno))
      if (listaprefinal.length > 0 || registro !== null) {
        let htmlstring = ''
        if (registro !== null && registro.id_beca !== null) {
          htmlstring = `Indicar si <b>${registro.nombreCompleto}<b> conserva su <b>${registro.beca_desc}</b> | <b>${registro.beca}</b>
                        <div class="radiosbutton">
                        <br><input checked type="radio" id="radiomantiene" name="radiobeca" value="mantiene">
                        <label for="radiosi">SI</label>
                        <input type="radio" id="radionueva" name="radiobeca" value="pierde">
                        <label for="css">NO</label><br>                      
                        </div>`
        }
        vm.$swal({
          title: 'Reinscripción',
          html: htmlstring,
          icon: 'warning',
          width: '40em',
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            const personas = []
            const tipoBeca = []
            let periodo = null
            let planestudios = null
            let enrolaut = null
            if (registro === null) { // es una lista
              periodo = listaprefinal[0].next_periodo
              planestudios = listaprefinal[0].id_plan
              enrolaut = listaprefinal[0].enrolaut_next_periodo
              listaprefinal.forEach(element => {
                const found = tipoBeca.find(elemento => elemento.id_beca === element.id_beca)
                personas.push({
                  id_persona: element.id_persona, beca: element.id_beca, status_actual: element.id_alu_status, d: element.d,
                })
                if (found === undefined && element.id_beca !== null) tipoBeca.push({ id_beca: element.id_beca, tipo: element.beca })
              })
            } else { // es un solo registro
              periodo = registro.next_periodo
              planestudios = registro.id_plan
              enrolaut = registro.enrolaut_next_periodo
              let idbecarecursamiento = registro.id_beca
              if (idbecarecursamiento !== null) {
                if (Array.from(document.getElementsByName('radiobeca')).find(radio => radio.checked).value === 'pierde') { idbecarecursamiento = null }
              }
              let statusAgenda = registro.id_alu_status
              if (statusAgenda === 7) statusAgenda = 3
              personas.push({
                id_persona: registro.id_persona, beca: idbecarecursamiento, status_actual: statusAgenda, d: registro.d,
              })
              const found = tipoBeca.find(elemento => elemento.id_beca === idbecarecursamiento)
              if (found === undefined && idbecarecursamiento !== null) tipoBeca.push({ id_beca: idbecarecursamiento, tipo: registro.beca })
            }
            const listafinal = {}
            listafinal.alumnos = personas
            listafinal.becas = tipoBeca
            const params = new FormData()
            loader.value = true
            params.append('task', 'wsalumno')
            params.append('origin', process.env.VUE_APP_ORIGIN_API)
            params.append('token', store.state.cuenta.session.token)
            params.append('action', 11)
            params.append('periodo', periodo)
            params.append('plan_estudios', planestudios)
            params.append('enrolaut', enrolaut)
            params.append('data', JSON.stringify(listafinal))
            postData(params)
              .then(response => {
                if (response && response.data && response.data.status === 200) {
                  let mensaje = ''
                  if (registro === null) mensaje = `<b>${listaprefinal.length} Alumnos Reinscritos.</b>`// es una lista
                  else mensaje = `Alumno <b>${registro.nombreCompleto} Reinscrito.</b>`
                  loader.value = false
                  vm.$swal({
                    icon: 'success',
                    allowOutsideClick: false,
                    title: 'Re-Inscripción Completa!',
                    html: `${mensaje}`,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  }).then(result2 => {
                    if (result2.value) {
                      if (registro === null) {
                        if (listaprefinal.length > 30) window.location.reload(true)
                        else {
                          const tipo = varFilters.value.tipoAlumno
                          varFilters.value.tipoAlumno = null
                          actualizarTabla(tipo)
                        }
                      } else if (response.data.data) {
                        const index = dataAux.value.findIndex(object => object.matricula === registro.matricula)
                        dataAux.value[index].ordenes.push({
                          fecha: null,
                          id: response.data.data.orden ?? 0,
                          observaciones: '',
                          precioFinal: 0,
                          referencia: null,
                        })
                        dataAux.value[index].orden_activa = 2
                        dataAux.value[index].automatico = 1
                      }
                    }
                  })
                } else if (response && response.data) {
                  cancelar(`Error en respuesta del servicio: <b>${response.data.message}.</b>`)
                } else {
                  loader.value = false
                  vm.$swal({
                    title: 'Warning',
                    html: '<b>El proceso fue realizado pero, algo a pasado en la respuesta del servicio, revisar con Soporte </b>',
                    icon: 'warning',
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                }
              })
              .catch(err => {
                cancelar(`Error - API reinscripción catch <b>${err}.</b>`)
              })
          } else if (result.dismiss === 'cancel') cancelar('Tal vez en otra ocasión')
        })
      } else cancelar('No hay alumnos que cumplan los criterios de Re-Inscripcion automática')
    }
    const fetchCatalogosFilters = () => {
      // varFilters.value.tipoAlumno = 'RB'
    }
    const checkresolucion = datos => {
      let r = false
      if (datos.findIndex(solicitudes => solicitudes.resolucion === 1) > -1) r = true
      return r
    }
    const promesas = id => {
      store.dispatch('reinscripcion/nivelOptionsPromise', id)
        .then(response => {
          nivelOptions.value = response
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
        })
    }
    //* On mounted
    onMounted(() => {
      fetchCatalogosFilters()
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
    })
    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(varFilters.value, () => {
      configRequest.value.agenda = varFilters.value.agenda
      configRequest.value.ordenactiva = varFilters.value.orden
      configRequest.value.nivel = varFilters.value.nivel
      configRequest.value.tipoAlumnof = varFilters.value.tipoAlumno

      refetchData()
    }) //* Any change in config params (filters), refetch table data
    // idplan
    watch(() => idplan.value, value => {
      promesas(value)
    })

    return {
      checkresolucion,
      numeroRB,
      numeroBA,
      numeroRC,
      numeroRO,
      fetchData,
      dataAux,
      tableColumns,
      useUsuariosCatalogos,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      lastUpdate,
      formatDate,
      updatedAt,
      timestampToDate,
      nombreModalidad,
      avatarText,
      configRequest,
      isBusyTable,
      errorContent,
      idplan,
      idperiodo,
      loader,
      random,
      loadusuarios,
      reinscribirlista,
      cancelar,
      stoppageload,
      // filtros catalogos
      agendaOptions,
      ordenOptions,
      varFilters,
      actualizarTabla,
      routeData,
      shipcode,
      nivelOptions,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.radiosbutton input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  border-radius: 50%;
  width: 26px;
  height: 26px;

  border: 2px solid #999;
  transition: 0.2s all linear;
  margin-right: 5px;

  position: relative;
  top: 4px;
}

.radiosbutton input:checked {
  border: 8px solid #008645 ;
  outline: unset !important /* I added this one for Edge (chromium) support */
}
</style>
